export default __webpack_public_path__ + "static/media/mlh-trust-badge-2022-black.dcbb855c.svg";